define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/table",
	"csi/table/Aggregate",
	"csi/xml"
], function(declare,lang,csi,_,table,Aggregate,xml) {

	return declare(Aggregate, {
		getFormData: function() {
			// summary: existing questions are stored at template revision, so need special code to determine if they are already selected
			var	fd = this.inherited(arguments);
			fd.m_fAggregateSelected = lang.hitch(this, this._isQuestionPreSelected);

			if (this.getNode() && this.getNode().Questions) {
				fd.resetAggregations();
			}

			return fd;
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add appended rows to request
			return this.inherited(arguments, [urlsNew.concat(this.urlsAppended)]);
		},

		toWriterRequest: function(/*FormData?*/fd) {
			// summary: remove subsections if child question is selected
			fd = fd || this.m_formData;
			var	cache = this.m_cache;
			var	nodes = fd.getSelectedNodes();
			var	obj = csi.hashArray(fd.getSelectedNodes(), "$URL", Boolean);

			this.urlsAppended = _.filter(this.urlsAppended, function(url) {
				var	node = cache.getNode(url);
				if (node.Questions && _.some(node.Questions, function(qurl) { return obj[qurl]; })) {
					return false;
				}

				return true;
			});

			// pass template revision as parent URL rather than node where action invoked
			return this._writeRequest().addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.widget._getViewNode().$URL);
		},

		_isQuestionPreSelected: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: return true if question is already in template
			return this.widget.getQuestionsByUrl()[ctx.getNodeURL()];
		},

		_preActionRequests: function(/*Request[]*/requests) {
			// summary: cache already has current selections
		}

	});
});